<div class="authPage">
  <div class="authFormPane">
    <a class="authLogo" routerLink="/login">
      <div class="logoBox"><img src="assets/img/icons/envision-menu-72px.png" alt="Urbanhub"></div>
      <span class="logoText"><b>Urban</b>hub</span>
    </a>

    <div class="authFormContent">
      <div>
        <a class="authLink authReturn" routerLink="../../login">{{ 'GENERAL.RETURN_LOGIN' | translate }}</a>
        <h1 class="authTitle">{{ 'RECOVERY.TITLE' | translate }}</h1>
        <p class="authSubtitle">{{ 'RECOVERY.SUBTITLE' | translate }}</p>
      </div>

      <form class="authForm" [formGroup]="form" (ngSubmit)="submit()">
        <div>
          <div class="authField">
            <label for="newPassword">{{ 'RECOVERY.NEW_PASSWORD' | translate }}</label>
            <mat-form-field appearance="outline" class="customMatFormField">
              <input id="newPassword" [type]="hideNewPassword ? 'password' : 'text'" matInput
                formControlName="newPassword" autocomplete="new-password">
              <div matSuffix [innerHTML]="icons[hideNewPassword ? 'visibility-off-outline' : 'visibility-outline']"
                class="pointer authFieldIcon" [class.hideIcon]="hideNewPassword" [class.showIcon]="!hideNewPassword"
                (click)="changeVisibility('new')"></div>
            </mat-form-field>
          </div>

          <div class="passwordHint">
            <span class="authHint">{{ 'RECOVERY.HINT' | translate }}</span>
            <div class="strengthBar" [attr.data-strength]="passwordStrength">
              @for (segment of [0, 1, 2, 3]; track segment) {
                <div class="segment" [class.filled]="passwordStrength > segment"></div>
              }
            </div>
          </div>
        </div>

        <div class="authField">
          <label for="confirmedNewPassword">{{ 'RECOVERY.CONFIRMED_NEW_PASSWORD' | translate }}</label>
          <mat-form-field appearance="outline" class="customMatFormField">
            <input id="confirmedNewPassword" [type]="hideConfirmedNewPassword ? 'password' : 'text'" matInput
              formControlName="confirmedNewPassword" autocomplete="new-password">
            <div matSuffix
              [innerHTML]="icons[hideConfirmedNewPassword ? 'visibility-off-outline' : 'visibility-outline']"
              class="pointer authFieldIcon" [class.hideIcon]="hideConfirmedNewPassword"
              [class.showIcon]="!hideConfirmedNewPassword" (click)="changeVisibility('confirmed')"></div>
          </mat-form-field>
        </div>

        @if (error && error !== undefined && error !== '') {
          <mat-error>
            {{ error }}
          </mat-error>
        }

        @if (success) {
          <p class="authSuccess">
            {{ 'RECOVERY.' + success | translate }}
          </p>
        }

        <button id="confirmButton" type="submit" mat-flat-button class="actionButton authSubmit">
          {{ 'RECOVERY.CONFIRM' | translate }}
        </button>
      </form>
    </div>
  </div>

  <div class="authVisualPane">
    <img class="authCityImg" src="assets/img/auth/city-square-light.png" alt="">
  </div>
</div>
